import { useState } from 'react';
import classNames from 'classnames';
import { FilterPicker, KeyboardDatePicker, MenuItem, Select, Typography } from 'seagull';
import { formatNumericUSDate } from "../../../../utils";
import { DateRange } from "../types";
import styles from "./DateRangeWithPresets.module.scss";
import { calculateEndDate, calculateStartDate, dataRangeNames, dateRangeOptions } from "./DateRangeWithPresets.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DateRangeWithPresets = props => {
  var _props$customDateLimi, _props$customDateLimi2, _props$customDateLimi3, _props$customDateLimi4, _props$customDateLimi5, _props$customDateLimi6, _props$customDateLimi7;
  const [endDate, setEndDate] = useState(props.endDate);
  const [startDate, setStartDate] = useState(props.startDate);
  const [dataRangeOption, setDataRangeOption] = useState(props.dataRangeOption || DateRange.Last12Months);
  const updateDataRangeOption = nextDataRangeOption => {
    const startDate = calculateStartDate(formatNumericUSDate(props.now), nextDataRangeOption, props.now);
    const endDate = calculateEndDate(formatNumericUSDate(props.now), nextDataRangeOption, props.now);
    setDataRangeOption(nextDataRangeOption);
    setStartDate(startDate);
    setEndDate(endDate);
  };
  return /*#__PURE__*/_jsxs(FilterPicker, {
    startOpen: props.startOpen,
    removable: props.removable,
    onRemove: props.onRemove,
    testId: "".concat(props.testIdPrefix, "-data-range-picker"),
    label: dataRangeNames[dataRangeOption](startDate, endDate),
    title: props.title,
    highlightTrigger: false,
    popoverWidth: 380,
    onApply: () => props.onApply(dataRangeOption, startDate, endDate),
    onClose: () => {},
    children: [/*#__PURE__*/_jsxs("div", {
      className: classNames(styles.row, styles.rangePicker),
      children: [/*#__PURE__*/_jsx(Select, {
        collapseHelperText: false,
        className: styles.dataRangeDropdown,
        value: dataRangeOption,
        onChange: e => updateDataRangeOption(e.target.value),
        testId: "revenue-breakdown-report-data-range-dropdown",
        children: dateRangeOptions.map((_ref, idx) => {
          let {
            value,
            text
          } = _ref;
          return /*#__PURE__*/_jsx(MenuItem, {
            value: value,
            testId: "revenue-breakdown-report-data-range-option-".concat(idx),
            children: text
          }, value);
        })
      }), ![DateRange.AllTime, DateRange.Custom].includes(dataRangeOption) && /*#__PURE__*/_jsxs(Typography, {
        testId: "revenue-breakdown-report-data-range-helper-text",
        variant: "paragraph1",
        noWrap: true,
        children: [startDate, " - ", endDate]
      })]
    }), dataRangeOption === DateRange.Custom ? /*#__PURE__*/_jsxs("div", {
      className: styles.row,
      children: [/*#__PURE__*/_jsx(KeyboardDatePicker, {
        testId: "revenue-breakdown-report-data-range-start-date-picker",
        className: styles.customDatePicker,
        value: startDate,
        onChange: date => {
          if (date != null) {
            setStartDate(formatNumericUSDate(date));
            if (endDate == null || date > new Date(endDate)) {
              setEndDate(formatNumericUSDate(date));
            }
          }
        },
        minDate: ((_props$customDateLimi = props.customDateLimits) === null || _props$customDateLimi === void 0 ? void 0 : _props$customDateLimi.min) || new Date('2023-01-01'),
        maxDate: (_props$customDateLimi2 = props.customDateLimits) === null || _props$customDateLimi2 === void 0 ? void 0 : _props$customDateLimi2.max,
        minDateMessage: (_props$customDateLimi3 = props.customDateLimits) === null || _props$customDateLimi3 === void 0 ? void 0 : _props$customDateLimi3.minDateMessage,
        maxDateMessage: (_props$customDateLimi4 = props.customDateLimits) === null || _props$customDateLimi4 === void 0 ? void 0 : _props$customDateLimi4.maxDateMessage
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        noWrap: true,
        children: "\xA0-\xA0"
      }), /*#__PURE__*/_jsx(KeyboardDatePicker, {
        testId: "revenue-breakdown-report-data-range-end-date-picker",
        className: styles.customDatePicker,
        value: endDate,
        onChange: date => date != null && setEndDate(formatNumericUSDate(date)),
        minDate: startDate,
        maxDate: (_props$customDateLimi5 = props.customDateLimits) === null || _props$customDateLimi5 === void 0 ? void 0 : _props$customDateLimi5.max,
        minDateMessage: (_props$customDateLimi6 = props.customDateLimits) === null || _props$customDateLimi6 === void 0 ? void 0 : _props$customDateLimi6.minDateMessage,
        maxDateMessage: (_props$customDateLimi7 = props.customDateLimits) === null || _props$customDateLimi7 === void 0 ? void 0 : _props$customDateLimi7.maxDateMessage
      })]
    }) : null]
  });
};
export default DateRangeWithPresets;